import { Color, Flex, Input, Spacing, Text } from '@billy/design-system'
import { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'

import { useAutomaticPaymentRemindersModalForm } from '@features/invoicingSettings/modules/paymentsAndReminders'
import { useUserOrganization } from '@modules-deprecated/app/organization'

export const AutomaticPaymentRemindersEmailSubject = (): ReactElement | null => {
  const { t } = useTranslation()
  const { automaticPaymentRemindersModalForm } = useAutomaticPaymentRemindersModalForm()
  const { FormItem, watch } = automaticPaymentRemindersModalForm
  const { isLoading, organization } = useUserOrganization()
  const emailSubject = watch('emailSubject')

  if (isLoading) {
    return null
  }

  return (
    <Flex flexDirection="column" gap={Spacing.S4}>
      <FormItem
        label={t('settings.organization.external_invoice.automatic_payment_reminders.modal.form.email_subject.label')}
        name="emailSubject"
        render={({ field }) => {
          return <Input {...field} />
        }}
      />
      <Text color={Color.Grey700} inline variant="bodySM">
        {t('settings.organization.external_invoice.automatic_payment_reminders.modal.form.email_subject.preview', {
          emailSubject,
          email: organization?.email,
        })}
      </Text>
    </Flex>
  )
}
